// extracted by mini-css-extract-plugin
export default {"strip":"pps2K"};